import { LightningElement } from "lwc";
import { logger } from "@devforce/trailhead-client-logger";

const toastDefaults = {
  duration: 6000,
  variant: "info",
  message: "",
  toasterName: "",
};
let toasts = [];
let uid = 0;
let elementCallback;
const updateElementAfter = (fn) => {
  return (arg) => {
    let result = fn(arg);
    elementCallback && elementCallback();
    return result;
  };
};
const removeToast = updateElementAfter((key) => {
  toasts = toasts.filter((t) => t.key !== key);
});
const showToast = updateElementAfter((options) => {
  uid++;
  let key = `toast-${uid}`;
  let timer;
  const toast = {
    ...toastDefaults,
    ...options,
    key,
    onClose: () => {
      const customEvent = new CustomEvent("toasterclosed", {
        detail: {
          toasterName: toast.toasterName,
        },
      });
      removeToast.call(null, key);
      document.dispatchEvent(customEvent);
      // Clear the previously registered timer
      if (timer) {
        clearTimeout(timer);
      }
    },
  };
  if (toast.duration) {
    timer = window.setTimeout(toast.onClose, toast.duration);
  }
  toasts = [...toasts, toast];
});
const reset = () => {
  updateElementAfter(() => {
    toasts = [];
  })(undefined);
};
class toaster extends LightningElement {
  toasts = [];

  /**
   * The toaster is a singleton where there is a single set of toasts where only
   * one component instance should be present on any given page. As such, the
   * component checks if there is already an element handling toasts to prevent
   * duplicate toasts from displaying.
   */
  connectedCallback() {
    if (!elementCallback) {
      elementCallback = this.update;
      this.update();
    } else {
      logger.warn(
        "An instance of tds-toaster is already present. Only the first instance will render toasts."
      );
    }
  }
  disconnectedCallback() {
    if (elementCallback === this.update) {
      elementCallback = undefined;
    }
  }
  update = () => {
    this.toasts = toasts;
  };
}

export default toaster;
export { reset, showToast };
